import React, { useState } from 'react';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { ClientSuggestion } from '../../interfaces/clients';

type ItemProps = {
  isBeingRemoved?: boolean;
  client: ClientSuggestion;
  removeButtonAction: Function;
};

const RemoveButton: React.FC<ItemProps> = ({ removeButtonAction, isBeingRemoved, client }) => {
  const [isHovered, setIsHovered] = useState(false);
  const icon = isBeingRemoved ? (
    <RemoveCircleIcon data-testid="removeButtonIcon" color={'error'} />
  ) : (
    <RemoveCircleOutlineIcon
      data-testid="removeButtonIconOutline"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      color={isHovered ? 'error' : 'disabled'}
    />
  );

  return (
    <div onClick={() => removeButtonAction(client)} style={{ cursor: 'pointer' }}>
      {icon}
    </div>
  );
};

export default RemoveButton;
